class PlatformsApi {
    static getAll() {
        return axios.get('/api/platforms')
            .then(response => response.data);
    }
}

export default PlatformsApi;
